import { render, staticRenderFns } from "./partnersEquityInfo.vue?vue&type=template&id=02465c20&scoped=true&"
import script from "./partnersEquityInfo.vue?vue&type=script&lang=js&"
export * from "./partnersEquityInfo.vue?vue&type=script&lang=js&"
import style0 from "./partnersEquityInfo.vue?vue&type=style&index=0&id=02465c20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02465c20",
  null
  
)

export default component.exports